@if (form) {
	<form [formGroup]="form">
		<ng-container formGroupName="booker">
			<p class="u-title-sub u-m-bottom--xs">{{ 'BOOKING.DETAILS.TITLE' | translate }}</p>
			<p [innerHTML]="'BOOKING.DETAILS.DESCRIPTION' | translate" class="u-m-bottom--sm"></p>

			<div class="u-row">
				<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.FIRSTNAME' | translate" name="firstName" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
				</tvcore-input>

				<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.LASTNAME' | translate" name="lastName" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
				</tvcore-input>
			</div>

			<div class="u-row">
				<tvcore-input class="u-col-sm--12 u-col--6" [label]="'BOOKING.DETAILS.EMAIL' | translate" name="email" type="email" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
					<tvcore-input-error name="pattern">{{ 'FORM.ERROR.EMAIL_INVALID' | translate }}</tvcore-input-error>
				</tvcore-input>

				<tvcore-input class="u-col-sm--12 u-col--6" [label]="'BOOKING.DETAILS.ALT_EMAIL' | translate" name="alternativeEmail" type="email" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
					<tvcore-input-error name="pattern">{{ 'FORM.ERROR.EMAIL_INVALID' | translate }}</tvcore-input-error>
				</tvcore-input>
			</div>

			<div class="u-row">
				<tvcore-input class="u-col-sm--12 u-col--6" [label]="'FORM.FIELD.PHONE' | translate" name="phone" type="tel" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
					<tvcore-input-error name="format">{{ 'FORM.ERROR.PHONE_INVALID' | translate }}</tvcore-input-error>
				</tvcore-input>

				<tvcore-input class="u-col-sm--12 u-col--6" [label]="'BOOKING.DETAILS.AGE' | translate" name="age" type="number" [showErrors]="showErrors">
					<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
					<tvcore-input-error name="min">{{ 'FORM.ERROR.MORE_OR_EQUAL' | translate: { min: 18 } }}</tvcore-input-error>
				</tvcore-input>
			</div>
		</ng-container>

		<p class="u-title-sub u-m-top--md u-m-bottom--xs">{{ 'BOOKING.DETAILS.COMPANION.TITLE' | translate }}</p>
		<p
			[innerHTML]="(type === OffersType.DAYTRIP ? 'BOOKING.DETAILS.COMPANION.DESCRIPTION_DAYTRIP' : 'BOOKING.DETAILS.COMPANION.DESCRIPTION_ACCOMMODATION') | translate"
			class="u-m-bottom--sm"
		></p>

		<div formArrayName="companions">
			@for (group of companions.controls; track group) {
				<div class="c-companion u-m-bottom--sm">
					<div class="u-row" [formGroupName]="$index">
						<tvcore-input class="u-col-sm--12 u-col--4" [label]="'BOOKING.DETAILS.COMPANION.NAME' | translate" name="fullName" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
						</tvcore-input>

						<tvcore-input class="u-col-sm--12 u-col--2" [label]="'BOOKING.DETAILS.AGE' | translate" name="age" type="number" [showErrors]="showErrors">
							<tvcore-input-error name="required">{{ 'FORM.ERROR.REQUIRED' | translate }}</tvcore-input-error>
							<tvcore-input-error name="min">{{ 'FORM.ERROR.MORE_THEN_ZERO' | translate }}</tvcore-input-error>
						</tvcore-input>

						<tvcore-checkbox class="u-col-sm--12 u-col--4" name="eligibleForDiscount" [bgInherit]="true">{{ 'BOOKING.DETAILS.COMPANION.SOCIAL' | translate }}</tvcore-checkbox>
					</div>

					<button class="c-btn-link c-btn--with-icon" (click)="removeCompanion($index)" type="button">
						<tvcore-icon name="trash"></tvcore-icon>
						{{ 'BOOKING.DETAILS.COMPANION.REMOVE_BUTTON' | translate }}
					</button>
				</div>
			}

			@if (companions.length < 9) {
				<button class="c-btn-link c-btn--with-icon" (click)="addCompanion()" type="button">
					<tvcore-icon name="plus"></tvcore-icon>
					{{ 'BOOKING.DETAILS.COMPANION.ADD_BUTTON' | translate }}
				</button>
			}
		</div>
	</form>
}
